import { render, staticRenderFns } from "./WorkflowListingNew.vue?vue&type=template&id=44e940d7"
import script from "./WorkflowListingNew.vue?vue&type=script&lang=js"
export * from "./WorkflowListingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports